"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gql = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const GQLResponseType_1 = __importDefault(require("../GQLResponseType"));
const GQLType_1 = __importDefault(require("../GQLType"));
const gql = (config) => {
    const { model, type = GQLType_1.default.QUERY, params = {}, name, response, serializeKey } = config;
    let { fields } = config;
    if (model) {
        fields = fields || model['ALL_FIELDS'];
    }
    const reg = /["\n{}]/g;
    const keys = Object.keys(params);
    const paramRaw = keys.reduce((others, key) => Object.assign(others, { ['$' + key]: params[key] }), {});
    const variaRaw = keys.reduce((others, key) => Object.assign(others, { [key]: '$' + key }), {});
    const bracket = t => (t ? `(${t})` : '');
    const curly = t => (t ? `{${t}}` : '');
    if (fields !== 'NONE') {
        fields = curly(fields);
    }
    else {
        fields = '';
    }
    const parameters = bracket(JSON.stringify(paramRaw, null, 1).replace(reg, ''));
    const variables = bracket(JSON.stringify(variaRaw, null, 1).replace(reg, ''));
    const serialize = serializeKey ? ' @serialize(key: ["' + serializeKey + '"])' : '';
    if (response === GQLResponseType_1.default.COLLECTION) {
        fields = '{ items ' + fields + ' \n totalCount }';
    }
    const s = `
		${type} ${name} ${parameters} ${serialize}  {
			${name} ${variables} ${fields}
		}
	`;
    return (0, graphql_tag_1.default)(s);
};
exports.gql = gql;
exports.default = exports.gql;
